import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { SET_ONBOARDING_STEP } from '../../redux/actions/types';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';
import { useLocation } from 'react-router-dom';
import { scrollToFormAndSlide } from '../../utils/scrollUtils';
import NewLogo26 from './NewLogo26';

  const NewLogo = ({navigateToHome, setLoginModal, handleScroll, dummyRef, formScrollRef, formSwiperRef, handleFormSlide , loginEmailRef}) => {
  const dispatch = useDispatch();
  const step = useSelector((store) => store?.onBoarding?.step);
  const maxStep = useSelector((store) => store?.onBoarding?.maxStep);
  const isLoading = useSelector((store) => store?.onBoarding?.isLoading);
  const location = useLocation();
  const isOnBoarding = location.pathname.includes('/onboarding');
  const isLandingPage = location.pathname === '/';

  const width = window.innerWidth;
  const handleStepBack = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_BACK_BUTTON_CLICKED);
    dispatch({type: SET_ONBOARDING_STEP, payload: step - 1});
  }

  const handleStepForward = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FORWARD_BUTTON_CLICKED);
    dispatch({type: SET_ONBOARDING_STEP, payload: step + 1});
  }



  return (
  <div className='relative w-full'>
    {step > 1 && !isLoading && isOnBoarding && <FontAwesomeIcon icon={faArrowLeft} onClick={handleStepBack} className='text-lg text-white font-semibold absolute top-2 z-[99999] left-0 cursor-pointer'/>}
    {step >= 1 && step < maxStep && !isLoading && isOnBoarding && <FontAwesomeIcon icon={faArrowRight} onClick={handleStepForward} className='text-lg text-white font-semibold absolute top-2 z-[99999] right-0 cursor-pointer'/>}
      <div className={` relative w-full  text-white  ${(isLandingPage && window.innerWidth < 768) ? 'flex justify-start' : 'flex justify-center items-center mx-auto' } gap-2`}>
        <div className="w-full mx-auto h-full flex items-center justify-center">
      <NewLogo26 />
      </div>
       
    </div>
    {isLandingPage &&  <div className='underline underline-offset-2 cursor-pointer text-[14px] text-[#7FC241] absolute right-0 top-2' onClick={() => {handleScroll(dummyRef); handleFormSlide(formSwiperRef, 0);
     
     setTimeout(() => {
      loginEmailRef?.current?.focus()
     },1000);
      
     }}>Login</div>}
</div>
  )
}

export default NewLogo